import React, {
  useState,
}                    from 'react';
import PropTypes     from 'prop-types';
import InputControl  from '~/components/Input/InputControl';
import InputSelect   from '~/components/Input/InputSelect';
import MonthPicker   from '../monthPicker';
import GridContainer from '~/components/GridContainer';
import GridItem      from '~/components/GridItem';
import SaveAlt       from '@material-ui/icons/SaveAlt';
import { Button }    from '@material-ui/core';

function StatusBilling({
  csv,
  status,
  setStartDate,
  setEndDate
}){
  const [ statusName, setStatusName ] = useState('');

  return(
    <div style={{padding: 10}}>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={6} md={5}>
          <MonthPicker setStartDate={setStartDate} setEndDate={setEndDate}/>
        </GridItem>
        <GridItem xs={6} sm={3} md={4}>
          <InputControl
            value={statusName}
            label={'Status da compra'}
            inputComponent={InputSelect}
            name={'state'}
            onChange={({state}) => {
              setStatusName(state.name);
              status(state.id);
            }}
            InputProps={{
              placeholder: 'Todos',
              options: [
                {id: 'processing', name: 'Processando'},
                {id: 'approved', name: 'Aprovado'},
                {id: 'canceled', name: 'Cancelado'},
                {id: '', name: 'Todos'}
              ],
            }}
          />
        </GridItem>
        <GridItem xs={6} sm={3} md={3} style={{textAlign: 'right'}}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => csv()}
            endIcon={<SaveAlt />}
          >
            Exportar
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
}

StatusBilling.propTypes={
  csv: PropTypes.func.isRequired,
  status: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
};

export default StatusBilling;
